import { render, staticRenderFns } from "./ModalInvitoPerito.vue?vue&type=template&id=635aad4a"
import script from "./ModalInvitoPerito.vue?vue&type=script&lang=js"
export * from "./ModalInvitoPerito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports